const theme = {
  section: {
    width: '100vw',
    marginLeft: 'calc(50% - 50vw)',
    backgroundColor: '#fff',
  },
  container: {
    textAlign: 'center',
    width: '90%',
    maxWidth: '1100px',
    margin: '0 auto',
    padding: '10px 0',
  },
  title: {
    fontSize: 'calc(1.5rem + .5208333333vw)',
    marginBottom: '3vw',
  },
};

export default theme;
